module.exports = __webpack_public_path__ + "static/tetik-2d56b0789a32d9bb420dfcd6598ec882.webp";